"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PALLET_VOLUME_IN_CUBIC_IN = exports.STORAGE_MAX_PALLET_HEIGHT_IN_IN = exports.STORAGE_MAX_PALLET_WIDTH_IN_IN = exports.STORAGE_MAX_PALLET_LENGTH_IN_IN = exports.STORAGE_MAX_PALLET_WEIGHT_IN_LBS = void 0;
exports.STORAGE_MAX_PALLET_WEIGHT_IN_LBS = 1500;
exports.STORAGE_MAX_PALLET_LENGTH_IN_IN = 60;
exports.STORAGE_MAX_PALLET_WIDTH_IN_IN = 48;
exports.STORAGE_MAX_PALLET_HEIGHT_IN_IN = 40;
exports.PALLET_VOLUME_IN_CUBIC_IN = exports.STORAGE_MAX_PALLET_LENGTH_IN_IN * exports.STORAGE_MAX_PALLET_WIDTH_IN_IN * exports.STORAGE_MAX_PALLET_HEIGHT_IN_IN;
//# sourceMappingURL=StorageConstants.js.map